import React, {Component} from 'react';
import config from 'react-global-configuration';
import axios from "axios";
import jwt_decode from "jwt-decode";

class GetPaymentStatus extends Component {
    state = {
        host: 'https://{{host}}:{{port}}/integrationserver/getPaymentStatus',
        header: '\'authToken: {{token}}\'',
        rawdata: ' {',
        code: '"uuid": "e1d7b3ec-6398-11ea-9a9a-e5fd2b6c76ad"',
        codeClose: '}',
        purl:'https://{{host}}:{{port}}/integrationserver/getPaymentStatus',
        languageList:[],
        sourceCode: '',
        isDevOptionAccess: false
    }

    componentDidMount() {
        this.getDevOptionsPermission();
        axios.get(config.get('API_URL') + '/diyusers/getLanguageList',
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
            .then(response => {
                this.setState({
                    languageList: response.data.languages
                })
            })
            .catch(err => {
                console.log(err)
            });

             axios.post(config.get('API_URL') + '/diyusers/getCodeSinnpet',
                                                            {
                                                                language: 'csharp',
                                                                variant: 'RestSharp',
                                                                APIId: 2
                                                            },
                                                            {
                                                                headers: {
                                                                    Authorization: ` ${localStorage.usertoken}`
                                                                }
                                                            })
                                                            .then(response => {
                                                               //alert(response);
                                                                this.setState({
                                                                           sourceCode: response.data.snippet
                                                                       });
                                                            })
                                                            .catch(err => {
                                                                console.log(err)
                                                                //alert(err)
                                                            });

    }

    getDevOptionsPermission(){
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        if(AllAccessPermissions !== undefined) {
            AllAccessPermissions.map((permissionName, i) => {
                if (permissionName.access_type == 'Action' && permissionName.access_name == 'advance_developer_option') {
                    this.setState({
                        isDevOptionAccess: true
                    })
                }
            });
        }
    }

    OnLanguageChange = (e) => {
                 let languageValue = e.target.value;
                 var value = this.state.languageList.filter(function(item) {
                        return item.key == e.target.value
                     })
                 axios.post(config.get('API_URL') + '/diyusers/getCodeSinnpet',
                             {
                                 language: languageValue,
                                 variant: value[0].variant,
                                 APIId: 2
                             },
                             {
                                 headers: {
                                     Authorization: ` ${localStorage.usertoken}`
                                 }
                             })
                             .then(response => {
                                //alert(response);
                                 this.setState({
                                            sourceCode: response.data.snippet
                                        });
                             })
                             .catch(err => {
                                 console.log(err)
                                 //alert(err)
                             });
           }

    renderInputField() {
                       if(this.state.isDevOptionAccess === false) {
                         return <div></div>;
                       } else {
                            let ltLanguage = this.state.languageList.map(data => {
                                        if(data.key == 'csharp'){
                                             return <option selected value={data.key}>{data.label}</option>
                                        }
                                        else{
                                                return  <option value={data.key}>{data.label}</option>
                                            }
                                    })
                         return (
                             <div className="col-md-5 pCodeBody3">
                                 <label htmlFor="cars">Choose a Language :</label> &nbsp;
                                 <select id="Language" name="Language" className="langualeDrop" onChange={this.OnLanguageChange}>
                                     <option value="">Select...</option>
                                     {ltLanguage}
                                 </select>

                                 <h5 className="pCHead">Example Request</h5>
                                 <div className="pCodeBox">
                                     <div className="pcodeHead">
                                         getPaymentStatus
                                     </div>
                                     <div className="pcodeB">
                                        <pre>
                                            <code>
                                              {this.state.sourceCode}
                                            </code>
                                        </pre>

                                     </div>
                                 </div>
                             </div>
                         );
                       }
                     }

    render() {
        let ltLanguage = this.state.languageList.map(data => {
             if(data.key == 'csharp'){
                             return <option selected value={data.key}>{data.label}</option>
                        }
                        else{
                                return  <option value={data.key}>{data.label}</option>
                            }
        })

        return (
            <div>
                    <div className="col-md-7 leftBody">
                        <br />
                        <span className="post">POST</span> <span className="postHead"> getPaymentStatus</span>
                       <br />
                        <br />
                        <span className="pUrl"> {this.state.purl} </span>
                        <br />
                        <br />
                        <p className="diyJustify">
                            This API would be called by the Billing server to get the payment status of an invoice from Innoviti Integration server.
                        </p>

                        {/*<h6 className="postHead">Mandatory request parameters, </h6>*/}
                        <h6 className="diyTableBorFont">MANDATORY REQUEST PARAMETERS </h6>
                        <hr className="hrDiv" />
                        <table className="table-bordered diyTableBorFont">
                            <thead>
                            <tr>
                                <th className="diyTableBorFont p-l-5">Parameter</th>
                                <th className="diyTableBorFont p-l-5">Type</th>
                                <th className="diyTableBorFont p-l-5">Description</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>uuid</td>
                                <td>String</td>
                                <td>UUID received from sendInvoiceToPaymentQueue API</td>
                            </tr>
                            </tbody>
                        </table>
                        <br />

                        <h6 className="diyTableBorFont">HEADERS</h6>
                        <hr className="hrDiv" />
                        <small> Content-Type &nbsp;&nbsp;&nbsp;&nbsp;application/json  </small>
                        <br />
                        <small> authToken &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{'{{token}}'} </small>
                        <br />
<br/>
                        <h6>BODY raw </h6>
                        <hr className="hrDiv" />
                        <span className="pUrlBody">

                             <br/>

                            {'{'} <br />
                            {'  "uuid" : "e1d7b3ec-6398-11ea-9a9a-e5fd2b6c76ad"'}<br />
                            {'}'} <br />
                            <br />
                        </span>
                    </div>
                    {this.renderInputField()}
            </div>
        );
    }
}

export default GetPaymentStatus;